var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "activity-end-root" }, [
    _c(
      "div",
      {
        staticClass: "custom-nav-block",
        style: `padding-top:${_vm.barHeight}px`,
      },
      [
        _c("van-nav-bar", {
          staticClass: "van-bar",
          attrs: { title: "", "left-arrow": "" },
          on: { "click-left": _vm.closeWeb },
          scopedSlots: _vm._u([
            {
              key: "left",
              fn: function () {
                return [
                  _c("img", {
                    staticClass: "left-nav",
                    attrs: {
                      src: require("@/assets/packageAssets/common/arrow01.png"),
                      alt: "",
                    },
                  }),
                ]
              },
              proxy: true,
            },
          ]),
        }),
      ],
      1
    ),
    _c("div", { staticClass: "activity-tips" }, [
      _c("img", {
        attrs: { src: require("@/assets/packageAssets/common/act-end.png") },
      }),
      _c("div", [_vm._v(_vm._s(_vm.$t("lang.commonM.k367")))]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }